import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Define a classe de tema ANTES da primeira pintura (evita flash de tema errado).
// Mantém a mesma regra de resolveInitialTheme() no ThemeContext.
(() => {
  try {
    const stored = localStorage.getItem('nanoplay-theme');
    const prefersLight =
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: light)').matches;
    const theme =
      stored === 'light' || stored === 'dark'
        ? stored
        : prefersLight
        ? 'light'
        : 'dark';
    document.documentElement.classList.toggle('dark', theme === 'dark');
  } catch {
    document.documentElement.classList.add('dark');
  }
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
